import { render, staticRenderFns } from "./PointsRuleBox.vue?vue&type=template&id=70fe4c50&scoped=true"
import script from "./PointsRuleBox.vue?vue&type=script&lang=js"
export * from "./PointsRuleBox.vue?vue&type=script&lang=js"
import style0 from "./PointsRuleBox.vue?vue&type=style&index=0&id=70fe4c50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fe4c50",
  null
  
)

export default component.exports